export const AUTO_SCROLL_KEYS = Object.freeze({
  SCROLL_TAB: 'scrollTab',
  SCROLL_SESSION: 'scrollSession',
  SCROLL_SPEAKER: 'scrollSpeaker'
});

export const getAutoScrollData = () => {
  const { SCROLL_TAB, SCROLL_SESSION, SCROLL_SPEAKER } = AUTO_SCROLL_KEYS;

  if (typeof window !== 'undefined') {
    return {
      [SCROLL_TAB]: sessionStorage.getItem(SCROLL_TAB),
      [SCROLL_SESSION]: sessionStorage.getItem(SCROLL_SESSION),
      [SCROLL_SPEAKER]: sessionStorage.getItem(SCROLL_SPEAKER)
    };
  }
  return {
    [SCROLL_TAB]: null,
    [SCROLL_SESSION]: null,
    [SCROLL_SPEAKER]: null
  };
};

export const removeAutoScrollData = () => {
  const keys = Object.keys(AUTO_SCROLL_KEYS);
  if (typeof window !== 'undefined') {
    keys.forEach(key => sessionStorage.removeItem(AUTO_SCROLL_KEYS[key]));
  }
};
